import { Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

import Header from './components/Header';
import Home from './components/Home';
import UserSignUp from './components/UserSignUp';
import UserSignIn from './components/UserSignIn';
import ProjectFiles from './components/ProjectFiles';
import BigFile from './components/BigFile';
import DigiStore from './components/DigiStore';
import DigiStoreManager from './components/DigiStoreManager';
import DigiPrev from './components/DigiPrev';

import BeatBattle from './components/BeatBattle';
import BeatBin from './components/BeatBin';

import CheckOut from './components/CheckOut';
import InterestForm from './components/InterestForm';
import ProgrammingDisplay from './components/ProgrammingDisplay';
import PlaySelectParent from './components/PlaySelectParent';
import Dropzone from './components/Dropzone';
import RenderFiles from './components/RenderFiles';
import UserSignOut from './components/UserSignOut';
import Settings from './components/Settings';
import Authenticated from './components/Authenticated';

import FarmerTv from './components/FarmerTv';
import FarmerEps from './components/FarmerEps';

import Fundraiser from './components/Fundraiser';

import TheAdministrator from './components/TheAdministrator'
import CreateBid from './components/CreateBid'
import MemBidCreate from './components/MemBidCreate'
import MemItems from './components/MemItems'
import BidGallery from './components/BidGallery'

import PopCustom from './components/PopCustom';
import WebPopUp from './components/WebPopUp';
import SpecialProd from './components/SpecialProd';
import SpecialOffer from './components/SpecialOffer';
import ProductPay from './components/ProductPay';

import Footer from './components/Footer';
import NotFound from './components/NotFound';
import Podserv from './components/PodServ';
import PrivateRoute from "./components/PrivateRoute";

import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import Refund from "./components/Refund";
import Contact from "./components/Contact";

import { BeatBattleProvider } from './context/BeatBattleContext';



function App() {
  return (
    <BeatBattleProvider>
      <div className="app-container">

       

        <Header />

        <div className="content">
          <Routes>

            <Route path="/" element={<Home />} />
            <Route path="/signin" element={<UserSignIn />} />
            <Route path="/signup" element={<UserSignUp />} />

            <Route path="/projects/:projectId" element={<ProjectFiles />} />
            <Route path="/programming" element={<ProgrammingDisplay />} />
            <Route path="/renderfiles" element={<RenderFiles />} />

            <Route path="/digistore" element={<DigiStore />} />
            <Route path="/digimanager" element={<DigiStoreManager />} />
            <Route path="/digiprev/:userId" element={<DigiPrev />} />
            <Route path="/checkOut/:userId" element={<CheckOut />} />

            <Route path="/playselect" element={<PlaySelectParent />} />
            <Route path="/bigfile/:projectId" element={<BigFile />} />

            <Route path="/contact" element={<InterestForm />} />

            <Route path="/dropzone" element={<Dropzone />} />

            <Route path="/farmertv" element={<FarmerTv />} />
            <Route path="/farmereps" element={<FarmerEps />} />

            <Route path="/popcustom" element={<PopCustom />} />
            <Route path="/webpopup" element={<WebPopUp />} />
            <Route path="/specialprod" element={<SpecialProd/>} />
             <Route path="/specialoffer" element={<SpecialOffer/>} />
              <Route path="/languagebarriers" element={<ProductPay/>} />

            <Route path="/fundraiser" element={<Fundraiser />} />

            <Route path="/theAdministrator" element={<TheAdministrator />} />

            <Route path="/createBid" element={<CreateBid />} />
            <Route path="/memBid" element={<MemBidCreate />} />
            <Route path="/memitem" element={<MemItems />} />
            <Route path="/bidgallery" element={<BidGallery />} />

            <Route path="/beatbattle" element={<BeatBattle />} />
            <Route path="/beatbin" element={<BeatBin />} />

            <Route path="/editmedia" element={<Podserv />} />

            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/signout" element={<UserSignOut />} />

            <Route element={<PrivateRoute />}>
              <Route path="/authenticated" element={<Authenticated />} />
              <Route path="/settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<NotFound />} />

          </Routes>
        </div>

        <Footer />

      </div>
    </BeatBattleProvider>
  );
}

export default App;